/** @jsx jsx */
import { jsx } from 'theme-ui';
import View from '../View/View';

const tags = {
  largest: 'h1',
  large: 'h2',
  default: 'h3',
  small: 'h4',
  smallest: 'h5',
  section: 'h3',
};

export default function Title({ as, variant = 'default', children, ...rest }) {
  return (
    <View
      as={as || tags[variant] || tags.default}
      sx={{
        margin: 0,
        padding: 0,
        variant: `title.${variant}`,
      }}
      {...rest}
    >
      {children}
    </View>
  );
}
